import React from 'react';

const LocationOfficeHours = () => {
  const officeHours = [
    {
      day: 'Monday - Friday',
      time: '9:00 AM - 6:00 PM'
    },
    {
      day: 'Saturday',
      time: '9:00 AM - 2:00 PM'
    },
    {
      day: 'Sunday',
      time: 'Closed',
      isClosed: true
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-14 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          {/* Our Location - Takes 7 columns (more width) */}
          <div className="lg:col-span-8">
            <h2 className="font-bold  mb-6 md:mb-8">
              Our Location
            </h2>

            {/* Map and Content Container */}
            <div className="flex flex-col">
              {/* Map Container */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-1">
                <div className="relative h-[280px] md:h-[320px] lg:h-[350px]">
                  {/* Google Map Embed */}
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.4377625650563!2d78.35924007440515!3d17.438749401324944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93aa5c464c8b%3A0xc3ac6e14a66bcee2!2sTrendz%20Eternity!5e0!3m2!1sen!2sin!4v1768371937379!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Hyderabad Location Map"
                    className="w-full h-full"
                  />
                  
                  {/* Location Badge */}
                  <div className="absolute top-4 left-4 bg-white px-3 py-2 rounded-lg shadow-md">
                    <div className="flex items-center gap-2">
                      <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <p className="font-bold  ">Hyderabad</p>
                        <p className="text-gray-600">Telangana, India</p>
                      </div>
                    </div>
                  </div>

                  {/* View Larger Map Link */}
                  {/* <div className="absolute top-4 right-4">
                    <a
                      href="https://www.google.com/maps/place/Hyderabad,+Telangana/@17.412608,78.24323229999999,10z"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white px-3 py-2 rounded-lg shadow-md text-xs md: text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1 transition-colors duration-300"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      View larger map
                    </a>
                  </div> */}
                </div>
              </div>

              {/* Directions & Parking */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-md">
                <h3 className="font-bold  mb-2">
                  Directions & Parking
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Located in the heart of Hyderabad's tech district. Free parking available on-site. 
                  Easily accessible by metro, bus, and taxi services.
                </p>
              </div>
            </div>
          </div>

          {/* Office Hours - Takes 4 columns (less width) */}
          <div className="lg:col-span-4 lg:col-start-9">
            <h2 className="font-bold  mb-6 md:mb-8">
              Office Hours
            </h2>

            {/* Primary BG Container with rounded corners and padding */}
            <div className="bluebg rounded-2xl shadow-lg p-2 md:p-3 lg:p-4">
              {/* Office Image - Inside blue section with border visibility */}
              <div className="relative h-[180px] md:h-[200px] lg:h-[220px] overflow-hidden rounded-xl mb-2 md:mb-3">
                <img
                  src='/assets/getInTouch/office.svg'
                  alt="Office workspace"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Hours List */}
              <div className="space-y-3">
                {officeHours.map((schedule, index) => (
                  <div
                    key={schedule.id || index}
                    className="flex items-center justify-between py-2 border-b border-white border-opacity-20 last:border-0"
                  >
                    <span className="  font-medium">
                      {schedule.day}
                    </span>
                    <span
                      className={`font-semibold ${
                        schedule.isClosed ? 'text-gray-400' : ''
                      }`}
                    >
                      {schedule.time}
                    </span>
                  </div>
                ))}
              </div>

              {/* Emergency Support */}
              <div className="mt-4 pt-4 border-t border-white border-opacity-70">
                <p className=" text-center font-medium">
                  24/7 Emergency Support Available
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationOfficeHours;